import { c as _c } from "react/compiler-runtime";
import { useHotelCardStars } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars/hotel-card-stars.hook";
import { HotelCardStarsPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars/hotel-card-stars.types";
import { numberConvert } from "@website/utils/number-convert";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import isNumber from "lodash-es/isNumber";
import { FC } from "react";
export const HotelCardStars: FC<HotelCardStarsPropertiesType> = properties => {
  const $ = _c(8);
  const router = useCompatRouter();
  const {
    stars,
    showText: t0,
    color: t1,
    size: t2,
    starSize: t3
  } = properties;
  const showText = t0 === undefined ? true : t0;
  const color = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "responsive" : t2;
  const starSize = t3 === undefined ? "small" : t3;
  const {
    hotelStars
  } = useHotelCardStars(properties);
  let t4;
  if ($[0] !== color || $[1] !== hotelStars || $[2] !== router || $[3] !== showText || $[4] !== size || $[5] !== starSize || $[6] !== stars) {
    t4 = isNumber(stars) && stars > 0 ? <div className={size === "xSmall" ? "flex items-center" : size === "small" ? "flex h-4 items-center" : "flex h-4 items-center lg:h-6"} itemProp="starRating" itemScope={true} itemType="https://schema.org/Rating"><meta content={`${stars}`} itemProp="ratingValue" />{hotelStars}{showText && <div className={`mx-1 ${color === "neutral" ? "text-on-surface-medium-emphasis" : "text-on-surface-high-emphasis"}`}>{size !== "xSmall" && <span className={`truncate ${starSize === "medium" ? "text-caption lg:text-body-1" : "text-caption"}`}>{`${numberConvert(stars, {
            locale: router.locale
          })} ستاره`}</span>}</div>}</div> : null;
    $[0] = color;
    $[1] = hotelStars;
    $[2] = router;
    $[3] = showText;
    $[4] = size;
    $[5] = starSize;
    $[6] = stars;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};